import React, { Suspense, lazy } from 'react';
import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import { TwnelContext } from '@twnel/web-components';
import { getAppInfo } from 'src/data/selectors';
import { appId } from 'src/data/util';
import Header from './Header';
import Login from './Login';

// Most visits only need the login; the rest of the screens load on demand
const Register = lazy(() => import('./Register'));
const TerraLogin = lazy(() => import('./terra/Login'));
const TerraRegister = lazy(() => import('./terra/Register'));
const TerraHeader = lazy(() => import('./terra/Header'));

const GlobalStyle = createGlobalStyle`
  html, body, #react {
    height: 100%;
    margin: 0;
  }
  #react {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const enableRegister = ({ environment }) => environment === 'stage'
  || environment === 'beta'
  || environment === 'debug';

export default function App() {
  const appInfo = useSelector(getAppInfo);
  const showRegister = enableRegister(appInfo);
  return (
    <TwnelContext>
      <GlobalStyle />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/terra/*" element={<TerraHeader />} />
            <Route path="*" element={<Header showRegister={showRegister} />} />
          </Routes>
          <div style={{ flexGrow: 1 }} />
          <Routes>
            {showRegister ? (
              <Route path="/register" element={<Register />} />
            ) : null}
            <Route path="/terra/register" element={<TerraRegister />} />
            <Route path="/terra/*" element={<TerraLogin />} />
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <div style={{ flexGrow: 1 }} />
        <div
          style={{
            width: '100%',
            maxWidth: '1080px',
            padding: '90px 10px 10px',
            boxSizing: 'border-box',
            textAlign: 'right',
            fontWeight: 'bold',
            fontSize: '0.9rem',
            opacity: '0.4',
          }}
        >
          {appId(appInfo)}
        </div>
      </BrowserRouter>
    </TwnelContext>
  );
}
